// extracted by mini-css-extract-plugin
export default {"container":"_3O8qF","redDot":"_1F5zR"};